import api from "@/api/api-eLearn";

export async function postAdminAxios(payload) {
    return await api.post("NPCC/AdminRegistration", payload);
  }

export async function getUserListAxios(tenantId) {    
    return await api.get("NPCC/GetUserList?tenantId="+tenantId);
}